import { computed } from '@angular/core';
import { patchState, signalStoreFeature, type, withComputed, withMethods, withState } from '@ngrx/signals';
import { EntityId, EntityProps, EntityState } from '@ngrx/signals/entities';

export type SelectedEntityState = { selectedEntityId: EntityId | null };

export function withSelectedEntity<Entity>() {
  return signalStoreFeature(
    {
      state: type<EntityState<Entity>>(),
      props: type<EntityProps<Entity>>(),
    },
    withState<SelectedEntityState>({ selectedEntityId: null }),
    withMethods((store) => ({
      unselect: () => patchState(store, { selectedEntityId: null }),
      select: (state: { id: string }) => patchState(store, { selectedEntityId: state.id }),
    })),
    withComputed(({ entityMap, selectedEntityId }) => ({
      selectedEntity: computed(() => {
        const selectedId = selectedEntityId();
        return selectedId ? entityMap()[selectedId] : null;
      }),
    })),
  );
}
